import Toast from "components/toast";
import { _goToBack, _goToRoot, _pop } from "routers/helper";

export const onAddNoteRes = (res: { data: any }) =>
  Toast.success({ message: res.data.message });

export const onEditNoteRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onDeleteNoteRes = onEditNoteRes;
